import React from "react";
import { matchPath, useLocation } from "react-router";

import { TRANSLATION_SERVICE_URL } from "../../shared/Env";
import ROUTES from "../routes";

const MAX_TRANSLATING_PATH_CACHE_SIZE = 10;
const isTranslatingCache = new Map<string, boolean>();

function getIsTranslatingForPathname(pathname: string) {
  const cachedIsTranslating = isTranslatingCache.get(pathname);
  if (cachedIsTranslating !== undefined) {
    return cachedIsTranslating;
  }

  const matchedRouteDefiniton = ROUTES.find(routeDefinition =>
    matchPath(pathname, {
      exact: true, // App.tsx route switcher defaults to exact
      ...routeDefinition,
    }),
  );

  const isTranslating =
    (matchedRouteDefiniton?.isTranslated ?? false) && !!TRANSLATION_SERVICE_URL;

  isTranslatingCache.set(pathname, isTranslating);
  if (isTranslatingCache.size > MAX_TRANSLATING_PATH_CACHE_SIZE) {
    const oldestCachedPathname = isTranslatingCache.keys().next().value;
    if (oldestCachedPathname) {
      isTranslatingCache.delete(oldestCachedPathname);
    }
  }

  return isTranslating;
}

/**
 * Checks whether or not the current route should be translated.
 * @returns boolean
 */
export const useIsTranslating = () => {
  const { pathname } = useLocation();

  return React.useMemo(() => {
    return getIsTranslatingForPathname(pathname);
  }, [pathname]);
};
